<template>
  <div class="question">
    <div class="question__type size--l">{{ title }}</div>
    <h2 class="size--xxl">{{ question }}</h2>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    question: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
.question {
  padding-bottom: 0px;
  text-align: center;

  &__type {
    padding-bottom: 20px;
  }

  &__headline {}
}
</style>
